import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@vst/beam';
import { TFunction } from 'i18next';

import { ROUTES } from '@app/router/constants';
import { useNavigate } from '@app/hooks';
import { selectConfig } from '@app/redux/config';
import { Pages, Persona, selectStreamOnPromo, setCurrentPage } from '@app/redux/streamOnPromo';
import { postMessage as postMessageUtil } from '@app/redux/utils';
import { Domains, EventTypes, WindowMessageData } from '@app/types';

import styles from './CloseButton.module.scss';

type CloseButtonProps = {
  t: TFunction;
  buttonTextKey: string;
  namespace: string;
};

export const CloseButton = ({ t, buttonTextKey, namespace }: CloseButtonProps) => {
  const { persona } = useSelector(selectStreamOnPromo);
  const { goTo } = useNavigate();

  const { platform } = useSelector(selectConfig);
  const dispatch = useDispatch();

  const handleClick = (e: React.ChangeEvent<HTMLInputElement>, link: string) => {
    e.preventDefault();
    if (namespace === 'OrderConfirmation') {
      const message: WindowMessageData = {
        domain: Domains.General,
        eventType: EventTypes.VisitPlanUsage,
      };
      if (platform !== 'Web') {
        goTo(ROUTES.HOME);
        dispatch(postMessageUtil(message));
        return;
      }
      dispatch(postMessageUtil(message));
    }
    dispatch(setCurrentPage(Pages.login));

    goTo(ROUTES.HOME);
  };

  switch (persona) {
    case Persona.CARE_AGENT:
    case Persona.PARTNER:
      return (
        <Button data-cy="FlowEndButton" className={styles['button']}>
          {t('Close.Button')}
        </Button>
      );
    default:
      return (
        <Button
          data-cy="FlowEndButton"
          onClick={(e: any) => handleClick(e, t('PurchaseFlow.LearnMoreLink', { ns: 'StreamOn' }))}
          variant="primary"
          className={styles['button']}
        >
          {t(buttonTextKey)}
        </Button>
      );
  }
};
